class CrocsLoyalty extends HTMLElement {
	constructor() {
		super();

		this.message = new MeowcartLoyaltyMessage();
		this.spinner = new LoadingSpinner();
		this.form = this.querySelector('form.crocs_loyalty_register');
		this.errors = [];
		this.provider = {
			hostname: meowcart.api_url,
		};
		this.staging = 'https://' + Shopify.shop;
		this.selectors = {
			overlay: document.querySelector('.overlay'),
			modalContainer: '.modal-container',
			otpInputField: document.querySelectorAll('.otp-input-field'),
			modals: document.querySelectorAll('.modal-container .modal-popup'),
			submitBtn: document.querySelector('.continue'),
			phoneField: document.querySelector('.form_field input'),
			hidePassword: document.querySelectorAll('.field-icon'),
			pinField: '.modal-display .form_field input',
			pinForm: document.querySelector('form.PIN'),
			otpForm: document.querySelector('form.OTP'),
			configPinForm: document.querySelector('form.pin-config'),
			recoverPinForm: document.querySelector(
				'#loyalty-pin-recovery form.pin-config'
			),
			securityQuestionForm: document.querySelector(
				'form.security-questions'
			),
			questionRecoveryForm: document.querySelector(
				'form.recovery-question'
			),
			otpContainer: document.querySelector('.otp-request'),
			forgotPIN: document.querySelector('.PIN .forgot-pin'),
			emailRecovery: document.querySelector(
				'.recovery-question .recovery-email b'
			),
			questionRecovery: document.querySelectorAll(
				'.recovery-email .recovery-question, #loyalty-recovery-email .recovery-question'
			),
			changePhoneNumber: document.querySelectorAll(
				'.notification__info .underline-text, .content-start .underline-text, .close-modal, .back-to-login'
			),
			registerBtn: document.querySelector(
				'.new-customer .underline-text.blue'
			),
			policyBtn: document.querySelector('#loyalty-pin-config .policy'),
			otpMethodButtons: document.querySelectorAll('.otp-method-btn'),
			recoveryMethodButtons: document.querySelectorAll('.recovery-method-btn'),
			changePhoneNumberBtn: document.querySelectorAll('.change-phone-btn'),
			changeRecoveryMethodButtons: document.querySelectorAll('.change-recovery-method-btn'),
      backToLoginBtn: document.querySelectorAll('.back-to-login-btn'),
      backToHomepageBtn: document.querySelector('.back-to-homepage-btn'),
      newRegisterBtn: document.querySelector('.new-register-btn'),
      confirmNewRegisterBtn: document.querySelector('.confirm-new-register-btn'),
      newAccountOtpMethodButtons: document.querySelectorAll('.new-account-otp-method-btn'),
		};
		this.apiEndPoint = {
			login: meowcart.endpoints.idm.login,
			loginable: meowcart.endpoints.idm.loginable,
			loginWithOtp: meowcart.endpoints.idm.loginWithOtp,
			prepareRegister: meowcart.endpoints.idm.prepareRegister,
			confirmRegister: meowcart.endpoints.idm.confirmRegister,
			getSecurityQuestions: meowcart.endpoints.idm.securityQuestions,
			completeRegister: meowcart.endpoints.idm.completeRegister,
			createPin: meowcart.endpoints.idm.createPin,
			pinRecoveryByEmail: meowcart.endpoints.idm.recoveryEmail,
			pinRecoveryByZalo: meowcart.endpoints.idm.recoveryZalo,
			pinRecoveryBySecurityQuestion: meowcart.endpoints.idm.recoverySecurityQuestion,
			resetPinByCode: meowcart.endpoints.idm.recoverySecurityQuestionConfirm,
			myProfile: meowcart.endpoints.idm.myProfile,
			newAccount: meowcart.endpoints.idm.newAccount,
			verifyNewAccount: meowcart.endpoints.idm.verifyNewAccount,
			customerEmail: meowcart.endpoints.idm.customerEmail,
		};
		this.userData = {
			acceptable: '',
			phoneNumber: '',
			registerCode: '',
			PIN: '',
			sq1: '',
			aq1: '',
			sq2: '',
			aq2: '',
			recovery_code: '',
			Ta: null,
			otp: '',
			username: '',
			customerAccessToken: ''
		};
		this.securityQuestions = [];
		this.countdownInterval = null;
		this.otpExpireInterval = null;
    this.otpExpireAt = null;
		this.otpAttempts = 3;
		this.isSubmitting = false;
		this.isRegister = false;
		this.otpSubmitted = false;
		this.profile = {};
		this.loginable();
		this.closeModal();
		this.handleSecurityQuestionModalError();
	}

	removeQueryParameters(url) {
		if (url.includes('?')) {
			return url.split('?')[0];
		}
	}

	
	
	connectedCallback() {
		this.handleApiError();
		this.handlePinModal();
		this.hidePassword();
		this.handlePinConfigModalSubmit();
		this.getOtpValue();
		this.handleQuestionRecoveryModal();
		this.handlePinRecoverModalSubmit();
		this.selectors.pinForm.addEventListener(
			'submit',
			this.pinModalSubmit.bind(this)
		);
		this._completeRegisterBound = this.completeRegister.bind(this);
		this.selectors.securityQuestionForm.addEventListener(
			'submit',
			this._completeRegisterBound
		);
		this.selectors.configPinForm.addEventListener(
			'submit',
			this.pinConfigModalSubmit.bind(this)
		);
		this.selectors.questionRecoveryForm.addEventListener(
			'submit',
			this.questionRecoveryModalSubmit.bind(this)
		);
		this.selectors.recoverPinForm.addEventListener(
			'submit',
			this.recoveryPinModalSubmit.bind(this)
		);
		this.selectors.changePhoneNumber.forEach((element) => {
			element.addEventListener('click', this.closeModal.bind(this));
		});
		this.selectors.forgotPIN.addEventListener(
			'click',
			this.showRecoverPinMethodModal.bind(this)
		);
		this.selectors.emailRecovery.addEventListener(
			'click',
			this.requestRecoveryViaEmail.bind(this)
		);
		this.selectors.questionRecovery.forEach((element) => {
			element.addEventListener(
				'click',
				this.showQuestionRecoveryModal.bind(this)
			);
		});
		this.selectors.otpInputField.forEach((input) => {
			input.addEventListener('input', () => {
				this.getOtpValue();
			});

			input.addEventListener('keydown', (event) => {
				if (event.key === 'Backspace') {
					this.getOtpValue();
				}
			});
		});
		this.selectors.policyBtn.addEventListener(
			'click',
			this.showPolicyModal.bind(this)
		);
		this.selectors.otpMethodButtons.forEach((btn) => {
			btn.addEventListener('click', async () => {
				const channel = btn.getAttribute('data-method');
				this.showLoadingButton(btn);
				const registeredResponse = await this.onSubmit(channel);
				this.removeLoadingButton(btn);

				if (registeredResponse.success) {
					this.hide('loyalty-otp-method-modal');
					if(channel === 'sms') {
						this.hide('loyalty-zalo-account-not-existed');
					}
					this.show('loyalty-otp-modal');
					const refCode = registeredResponse?.data?.ref;
					this.showRefCode(refCode);
					this.countdown();
					this.otpInputFieldChanged();
				}
			});
		});
    this.selectors.newAccountOtpMethodButtons.forEach((btn) => {
			btn.addEventListener('click', async () => {
				const channel = btn.getAttribute('data-method');
				this.showLoadingButton(btn);
				await this.handleConfirmNewRegister(channel);
				this.removeLoadingButton(btn);
			});
		});
		this.selectors.changePhoneNumberBtn.forEach((btn) => {
			btn.addEventListener('click', async () => {
				this.hide('loyalty-zalo-account-not-existed');
			});
		});
    this.selectors.changeRecoveryMethodButtons.forEach((btn) => {
			btn.addEventListener('click', async () => {
				this.hideAllOpenModals();
        this.show('loyalty-recovery-pin-method-modal');
			});
		});
    this.selectors.backToLoginBtn.forEach((btn) => {
			btn.addEventListener('click', async () => {
				this.hideAllOpenModals();
			});
		});
    this.selectors.backToHomepageBtn.addEventListener('click', async () => {
      this.hideAllOpenModals();
      window.location.href = window.theme.routes.home || '/';
    });
    this.selectors.newRegisterBtn.addEventListener('click', async () => {
      this.hideAllOpenModals();
      this.show('loyalty-new-register-modal');
    });
		this.selectors.recoveryMethodButtons.forEach((btn) => {
			btn.addEventListener('click', async () => {
				const channel = btn.getAttribute('data-method');
				if (channel === 'zalo') {
					this.recoveryZalo(btn);
				} else if (channel === 'email') {
					this.requestRecoveryViaEmail(btn);
				} else if (channel === 'security_question') {
					this.showQuestionRecoveryModal(null, btn);
				}
			});
		});
    if (this.selectors.confirmNewRegisterBtn) {
      // this.selectors.confirmNewRegisterBtn.addEventListener('click', this.handleConfirmNewRegister.bind(this));
      this.selectors.confirmNewRegisterBtn.addEventListener('click', () => {
        this.hideAllOpenModals();
        this.show('loyalty-new-account-otp-method-modal');
      });
    }
	}
	handleApiError() {
		const urlParams = new URLSearchParams(window.location.search);
		const showAlert = urlParams.get('showAlert');

		if (showAlert === 'true') {
			alert('Đã có lỗi xảy ra. Vui lòng đăng nhập lại.');
		}
	}

	updateErrorMessage(errorMessage, errorContainerSelector, remainingMessage) {
		if (!errorMessage) {
			return;
		}

		const errorDiv = errorContainerSelector.querySelector(
			'div[data-reach-alert]'
		);

		if (errorDiv) {
			errorDiv.textContent = errorMessage + remainingMessage;
			errorDiv.setAttribute('data-reach-alert', 'true');
		} else {
			const newErrorDiv = document.createElement('div');
			newErrorDiv.setAttribute('data-reach-alert', 'true');
			newErrorDiv.textContent = errorMessage + remainingMessage;
			errorContainer.innerHTML = '';
			errorContainer.appendChild(newErrorDiv);
		}
	}

	errorHandling(errorCode) {
		const errors = this.message.errorNumber();
		const currentLang = this.message.currentLang;

		if (errors[errorCode]) {
			return errors[errorCode].message;
		} else {
			return currentLang === 'EN'
				? 'Must not be blanked'
				: 'Không được để trống';
		}
	}

	handleInputError(inputFieldSelector, errorCode, remainingMessage = '') {
		const inputField = document.querySelector(inputFieldSelector);
		const labelParentDiv = inputField.closest('.label-parent');
		const errorContainerSelector =
			inputField.parentElement.nextElementSibling;
		const errorMessage = this.errorHandling(errorCode);

		if (errorCode !== 200) {
			if (errorCode === 909) {
				labelParentDiv.classList.add('question-recovery-error-active');
			}
			labelParentDiv.classList.add('active');
		} else {
			labelParentDiv.classList.remove('active');
		}

		if (labelParentDiv.classList.contains('active')) {
			errorContainerSelector.style.display = 'block';
		} else {
			errorContainerSelector.style.display = '';
		}

		this.updateErrorMessage(
			errorMessage,
			errorContainerSelector,
			remainingMessage
		);
	}

	showPolicyModal() {
		console.log('showPolicyModal');
		// this.hide('loyalty-pin-config');
		// this.show('loyalty-policy');
	}
	showSpinner() {
		const spinner = document.querySelector('.spinner');
		spinner.classList.add('active');
	}

	hideSpinner() {
		const spinner = document.querySelector('.spinner');
		spinner.classList.remove('active');
	}

	async requestRecoveryViaEmail(button) {
		this.showLoadingButton(button || '.recovery-method-btn[data-method="email"]');

		try {
			await this.emailRecoveryModalSubmit();
		} finally {
			this.removeLoadingButton(button || '.recovery-method-btn[data-method="email"]');
		}
	}

	async recoveryZalo(button) {
		this.showLoadingButton(button || '.recovery-method-btn[data-method="zalo"]');
		const data = JSON.stringify({
			username: this.userData.phoneNumber,
		});

		try {
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.pinRecoveryByZalo
			);

			if (response.status === 200) {
				this.hideAllOpenModals();
				this.show('loyalty-recovery-zalo-success');
			}
		} catch (error) {
      this.hideAllOpenModals();
      clearInterval(this.countdownInterval);
			const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;

			if (error?.response.data.error_fields?.[0] === 951) {
        const zaloModal = document.getElementById('loyalty-recovery-zalo-account-not-existed');
        if (zaloModal) {
          const phoneElement = zaloModal.querySelector('.login-phone');
          if (phoneElement) {
            phoneElement.textContent = this.maskPhone(this.userData.phoneNumber);
          }
        }
        this.show('loyalty-recovery-zalo-account-not-existed');
			} else if (
        error?.response.data.error_fields?.[0] === 900 
        || error?.response.data.error_fields?.[0] === 901
      ) {
				this.handleAuthenticateLimit(
					timeRemaining,
					'loyalty-limit-request'
				);
			} else if (error?.response.data.error_fields?.[0] === 911) {
				this.handleAuthenticateLimit(
					timeRemaining,
					'loyalty-otp-limit'
				);
			} else if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			} else {
        this.handleInputError('input[name="register[phone]"]', error?.response.data.error_fields?.[0]);
      }

			return { success: false, data: error };
		} finally {
			this.removeLoadingButton(button || '.recovery-method-btn[data-method="zalo"]');
		}
	}

	async showQuestionRecoveryModal(event, button) {
		const parentSpan = event?.target?.closest('.recovery-question');

		const recoveryBtn = button || document.querySelector('.recovery-method-btn[data-method="security_question"]');
		this.showLoadingButton(recoveryBtn);
		const response = await this.getSecurityQuestions();
		this.removeLoadingButton(recoveryBtn);

		if (response.success) {
			this.initializeCustomSelects();
			new MeowcartCustomSelect().resetCustomSelects();

			if (parentSpan) {
				this.hide('loyalty-recovery-email');
				this.show('loyalty-recovery-question');
				this.handleSecurityQuestionsModal();
			} else {
				this.hideAllOpenModals();
				this.show('loyalty-recovery-question');
				this.handleSecurityQuestionsModal();
			}
		}
	}

	showRecoverPinMethodModal() {
		this.hide('loyalty-pin-modal');
		this.show('loyalty-recovery-pin-method-modal');
	}

	countdown() {
		let seconds = 60;
		let otpContainer = this.selectors.otpContainer;

		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}

    if (this.otpExpireInterval) {
      clearInterval(this.otpExpireInterval);
    }

    this.otpExpireAt = Date.now() + 3 * 60 * 1000;

    this.otpExpireInterval = setInterval(() => {
      if (Date.now() >= this.otpExpireAt) {
        clearInterval(this.otpExpireInterval);
        this.otpExpireInterval = null;
        this.otpExpireAt = null;
      }
    }, 1000);

		otpContainer.innerHTML = `
			<span>${this.message.loginOtpModal().desc_otp}</span><br> 
			<span>${this.message.loginOtpModal().receive_after}</span> <span class="loyalty-timer"></span>`;

		let timer = otpContainer.querySelector('.loyalty-timer');

		const tick = () => {
			seconds--;
			timer.innerHTML = (seconds < 10 ? '0' : '') + String(seconds) + 's';
			if (seconds <= 0) {
				clearInterval(this.countdownInterval);
				this.countdownInterval = null;

				let notificationInfoElement = document.querySelector(
					'.modal-display .OTP.notification__info'
				);

				if (notificationInfoElement) {
					notificationInfoElement.innerHTML = `
					<span class="notification__info-otp">
						${this.message.loginOtpModal().desc_with_phone} 
						<span class="user-phone-number">03*****982</span>.
					</span>
					<br>
					<span class="underline-text blue"><b> ${this.message.loginOtpModal().change} </b></span>
				`;
				}

				const changePhone = this.querySelector('.underline-text');
				if (changePhone) {
					changePhone.addEventListener('click', () => {
						const clickEvent = new MouseEvent('click', {
							view: window,
							bubbles: true,
							cancelable: true,
						});
						const overlay = this.selectors.overlay;
						if (overlay) {
							overlay.dispatchEvent(clickEvent);
						}
					});
				}

				const userPhoneNumberElement =
					document.querySelector('.user-phone-number');
				const maskedPhone =
					this.userData.phoneNumber.slice(0, 2) +
					'*****' +
					this.userData.phoneNumber.slice(7);
				userPhoneNumberElement.textContent = maskedPhone;

        otpContainer.innerHTML = `<span class="no-otp">${this.message.loginOtpModal().no_otp}</span> <span class="new-request underline-text blue">${this.message.loginOtpModal().request}</span>
          <p class="new-request blue change-method underline-text" style="margin: 12px 0 0 0">
            <b>${this.message.loginOtpModal().change_method}</b>
          </p>`;

				const changeMethodBtn = otpContainer.querySelector('.change-method');
				if (changeMethodBtn) {
					changeMethodBtn.addEventListener('click', () => {
						this.hideAllOpenModals();
            if (this.userData.isNewAccountFlow) {
              this.show('loyalty-new-account-otp-method-modal');
            } else {
              this.show('loyalty-otp-method-modal');
            }
					});
				}

				const updatedRequestNewOtp =
					document.querySelector('.new-request');
				let hasClicked = false;

				updatedRequestNewOtp.addEventListener(
					'click',
					() => {
						if (!hasClicked) {
							hasClicked = true;
							this.newOtpRequest();
						}
					},
					{ once: true }
				);
			}
		};

		this.countdownInterval = setInterval(tick, 1000);
	}

	initializeCustomSelects() {
		const selectElements = document.querySelectorAll(
			'.custom-select select'
		);
		selectElements.forEach((selectElement) => {
			if (selectElement.dataset.meowcartInitialized) {
				return;
			}

			const defaultOption = document.createElement('option');
			defaultOption.value = '';
			defaultOption.textContent = this.message.securityModal().select_question;
			defaultOption.disabled = true;
			selectElement.appendChild(defaultOption);

			this.securityQuestions.forEach((question) => {
				const optionElement = document.createElement('option');
				optionElement.value = question.id;
				const questionText = Shopify.locale === 'vi' ? question.questionVi : question.questionEng;
				optionElement.setAttribute(
					'data-question',
					questionText
				);
				optionElement.textContent = questionText;
				selectElement.appendChild(optionElement);
			});

			new MeowcartCustomSelect(selectElement).render();

			selectElement.dataset.meowcartInitialized = true;
		});
	}

	showLoadingButton(button) {
		const targetButton = typeof button === 'string' ? document.querySelector(button) : button;
		if (targetButton) {
			targetButton.classList.add('btn-loading');
			targetButton.style.pointerEvents = 'none';
			targetButton.disabled = true;
			if (targetButton.classList.contains('color-gray')) {
				targetButton.classList.add('color-black');
			}

			const container = targetButton.closest('.modal-popup') || targetButton.closest('.form_container') || targetButton.closest('.loyalty_register_left');
			if (container) {
				const otherButtons = container.querySelectorAll('button:not(.btn-loading), .otp-input-field, input');
				otherButtons.forEach(btn => btn.disabled = true);
			}
		}
	}

	removeLoadingButton(button) {
		const targetButton = typeof button === 'string' ? document.querySelector(button) : button;
		if (targetButton) {
			targetButton.classList.remove('btn-loading');
			targetButton.style.pointerEvents = '';
			targetButton.disabled = false;
			if (targetButton.classList.contains('color-black') && (targetButton.classList.contains('color-blue') || targetButton.classList.contains('color-gray'))) {
				targetButton.classList.remove('color-black');
			}

			const container = targetButton.closest('.modal-popup') || targetButton.closest('.form_container') || targetButton.closest('.loyalty_register_left');
			if (container) {
				const otherButtons = container.querySelectorAll('button, .otp-input-field, input');
				otherButtons.forEach(btn => btn.disabled = false);
			}
		}
	}

	hide(modalId) {
		const modal = document.getElementById(modalId);
    if (!modal) return;

    if (this.otpExpireInterval) {
      clearInterval(this.otpExpireInterval);
      this.otpExpireInterval = null;
      this.otpExpireAt = null;
    }

		const form = modal.querySelector('.crocs_loyalty_register');

		if (form) {
			form.reset();
		}

		if (modal) {
			if (modalId === 'loyalty-otp-modal') {
				this.otpSubmitted = false;

				let notificationInfoElement = modal.querySelector(
					'.modal-display .OTP.notification__info'
				);

				if (notificationInfoElement) {
					notificationInfoElement.innerHTML = `
						<span class="notification__info-otp">
							${this.message.loginOtpModal().desc}
						</span>
					`;
				}
			}

            if (modalId === 'loyalty-recovery-question') {
                const errorDiv = modal.querySelector('#email-recovery-error-message');
                if (errorDiv) {
                    errorDiv.remove();
                }
            }

			const errorFields = modal.querySelectorAll('.label-parent.active');
			const inputFields = modal.querySelectorAll('input');
			const modalButton = modal.querySelector('button');

			// if (!modalButton.classList.contains('back-to-login')) {
			// 	modalButton.classList.remove('black-button');
			// 	modalButton.disabled = true;
			// }

			if (modalId === 'loyalty-recovery-pin-method-modal') {
				const errorDiv = modal.querySelector('#email-recovery-error-message');
				if (errorDiv) {
					errorDiv.remove();
				}
			}

			errorFields.forEach((errorField) => {
				errorField.classList.remove('active');
				const errorContainerSelectors =
					errorField.querySelectorAll('.field-errors');

				if (errorContainerSelectors) {
					errorContainerSelectors.forEach((errorContainer) => {
						errorContainer.style.display = 'none';
					});
				}
			});

			inputFields.forEach((inputField) => {
				inputField.value = '';
			});

			modal.classList.remove('modal-display');
            document.documentElement.classList.remove('show-modal', 'no-scroll');
		}
	}

	show(modalId) {
		const modal = document.getElementById(modalId);
		if (modal) {
			document.documentElement.classList.add('show-modal', 'no-scroll');
			modal.classList.add('modal-display');
		}
	}

	hideAllOpenModals() {
		const openModals = document.querySelectorAll('.modal-popup.modal-display');
		openModals.forEach((modal) => {
			if (modal.id) {
				this.hide(modal.id);
			}
		});
	}

	closeModal() {
		const overlay = this.selectors.overlay;
		const changePhone = this.selectors.changePhoneNumber;

		const closeModalLogic = () => {
      if (this.otpExpireInterval) {
        clearInterval(this.otpExpireInterval);
        this.otpExpireInterval = null;
        this.otpExpireAt = null;
      }
  
			const modalContainer = this.querySelector(
				this.selectors.modalContainer
			);

			const modals = modalContainer.querySelectorAll('.modal-display');

			modals.forEach((modal) => {
                if (modal.id === 'loyalty-recovery-question') {
                    const errorDiv = document.querySelector('#email-recovery-error-message');
                    if (errorDiv) {
                        errorDiv.remove();
                    }
                }

				const form = modal.querySelector('.crocs_loyalty_register');

				if (form) {
					form.reset();
				}

				const otpForm = modal.querySelector('form.OTP');

				this.otpSubmitted = false;

				if (otpForm) {
					let notificationInfoElement = modal.querySelector(
						'.modal-display .OTP.notification__info'
					);

					notificationInfoElement.innerHTML = `
						<span class="notification__info-otp">
							${this.message.loginOtpModal().desc}
						</span>
					`;
				}

				const errorFields = modal.querySelectorAll(
					'.label-parent.active'
				);
				const inputFields = modal.querySelectorAll('input');
				const modalButton = modal.querySelector('button');
				// modalButton.classList.remove('black-button');
				// modalButton.disabled = true;

				errorFields.forEach((errorField) => {
					errorField.classList.remove('active');

					const errorContainerSelectors =
						errorField.querySelectorAll('.field-errors');

					if (errorContainerSelectors) {
						errorContainerSelectors.forEach((errorContainer) => {
							errorContainer.style.display = 'none';
						});
					}
				});

				inputFields.forEach((inputField) => {
					inputField.value = '';
				});

				modal.classList.remove('modal-display');
			});

			document.documentElement.classList.remove(
				'show-modal',
				'no-scroll'
			);
		};
		overlay.addEventListener('click', (e) => {
			if (window.location.pathname.includes('/account/login')) return;
			closeModalLogic(e);
		});
		changePhone.forEach((button) => {
			button.addEventListener('click', closeModalLogic);
		});
	}

	otpInputFieldChanged() {
		const inputs = this.selectors.otpInputField;

		inputs.forEach((input, index) => {
			input.addEventListener('keydown', (e) => {
				switch (e.key) {
					case 'ArrowRight':
						if (index < inputs.length - 1) {
							inputs[index + 1].focus();
						}
						break;
					case 'ArrowLeft':
						if (index > 0) {
							inputs[index - 1].focus();
						}
						break;
					case 'Backspace':
						if (input.value === '' && index > 0) {
							inputs[index - 1].focus();
							inputs[index - 1].value = '';
						} else {
							input.value = '';
						}
						break;
					case 'Enter':
						e.preventDefault();
						break;
				}
			});

			input.addEventListener('input', async (e) => {
				const target = e.target;
				const val = target.value;

				if (isNaN(val)) {
					target.value = '';
					return;
				}

				if (input.value && index < inputs.length - 1) {
					inputs[index + 1].focus();
				} else if (index === inputs.length - 1) {
					input.blur();
				}

				const isComplete = Array.from(inputs).every(
					(input) => input.value !== ''
				);

				if (isComplete && !this.isSubmitting && !this.otpSubmitted) {
					// if (this.countdownInterval) {
					if (this.otpExpireAt && Date.now() < this.otpExpireAt) {
						this.isSubmitting = true;
						const otpValue = Array.from(inputs)
							.map((input) => input.value)
							.join('');
						this.otpSubmitted = await this.otpModalSubmit(otpValue);
						this.isSubmitting = false;
					} else {
						this.selectors.otpContainer.innerHTML = `<span class="red font-500">${this.message.loginOtpModal().otp_expired}</span>`;
					}
				}
			});

			input.addEventListener('focus', () => {
				input.select();
				input.setSelectionRange(input.value.length, input.value.length);
			});

			input.addEventListener('paste', (e) => {
				this.handleOtpPaste(e, inputs);
			});
		});
	}

	handleOtpPaste(e, inputs) {
		e.preventDefault();

		const pasteData = e.clipboardData.getData('text');
		const otpDigits = pasteData.trim().split('');

		if (otpDigits.length === inputs.length) {
			inputs.forEach((input, index) => {
				input.value = otpDigits[index] || '';
			});

			const lastInput = inputs[inputs.length - 1];
			lastInput.focus();
			lastInput.blur();

			const inputEvent = new Event('input', { bubbles: true });
			lastInput.dispatchEvent(inputEvent);
		}
	}

	hidePassword() {
		const hideIcon = this.selectors.hidePassword;

		hideIcon.forEach((icon) => {
			icon.addEventListener('click', () => {
				const targetId = icon.getAttribute('data-target');
				const pinField = document.querySelector(targetId);
				const siblingIcon =
					icon.nextElementSibling || icon.previousElementSibling;

				if (pinField) {
					const isPasswordHidden = pinField.type === 'password';

					pinField.type = isPasswordHidden ? 'text' : 'password';

					icon.style.display = 'none';

					if (siblingIcon) {
						siblingIcon.style.display = 'inline-block';
					}
					setTimeout(() => {
						siblingIcon.addEventListener('click', () => {
							icon.style.display = 'inline-block';
							siblingIcon.style.display = 'none';
						});
					}, 100);
				} else {
					console.error('Không tìm thấy pinField!');
				}
			});
		});
	}

	/* HANDLE UI */
	handlePinRecoverModalSubmit() {
		const inputFields = document.querySelectorAll(
			'#recover-pin, #confirm-recover-pin'
		);
		const continueButton = document.querySelector('#continue-recover');

		continueButton.disabled = true;
		continueButton.classList.remove('black-button');

		let initialCheck = false;

		const validateForm = () => {
			const pinValue = inputFields[0].value.trim();
			const confirmPinValue = inputFields[1].value.trim();

			let isPinFieldValid = false;
			if (!pinValue) {
				this.handleInputError('input[name="recover-pin"]', 200);
			} else if (!/^\d+$/.test(pinValue)) {
				this.handleInputError('input[name="recover-pin"]', 602);
			} else if (this.isRepeatingOrSequential(pinValue)) {
				this.handleInputError('input[name="recover-pin"]', 600);
			} else {
				this.handleInputError('input[name="recover-pin"]', 200);
				isPinFieldValid = true;
			}

			let isConfirmPinFieldValid = false;
			if (!confirmPinValue) {
				this.handleInputError('input[name="confirm-recover-pin"]', 200);
			} else if (pinValue !== confirmPinValue) {
				this.handleInputError('input[name="confirm-recover-pin"]', 601);
			} else {
				this.handleInputError('input[name="confirm-recover-pin"]', 200);
				isConfirmPinFieldValid = true;
			}

			const isFormValid = isPinFieldValid && isConfirmPinFieldValid;

			continueButton.disabled = !isFormValid;
			if (isFormValid) {
				continueButton.classList.add('black-button');
			} else {
				continueButton.classList.remove('black-button');
			}
		};

		inputFields.forEach((input) => {
			input.addEventListener('input', () => {
				input.value = input.value.replace(/[^0-9]/g, '');
				initialCheck = true;
				validateForm();
			});
		});

		validateForm();
	}

	isRepeatingOrSequential(pin) {
		if (/^(\d)\1*$/.test(pin)) return true;

		if ('1234567890'.includes(pin)) return true;

		if ('0987654321'.includes(pin)) return true;

		return false;
	}

	handlePinConfigModalSubmit() {
		const inputFields = document.querySelectorAll(
			'#config-pin, #confirm-pin'
		);
		const checkboxes = document.querySelectorAll(
			'.pin-config .loyalty-checkbox'
		);
		const continueButton = document.querySelector('#continue-config');

		let allChecked = false;
		let initialCheck = false;

		const validateForm = () => {
			let inputValid = true;
			const pinValue = inputFields[0].value.trim();
			const confirmPinValue = inputFields[1].value.trim();

			const isEmptyPin = !pinValue;
			const isEmptyConfirmPin = !confirmPinValue;
			const isNumericPin = /^\d+$/.test(pinValue);
			const isNumericConfirmPin = /^\d+$/.test(confirmPinValue);
			const isConfirmed = pinValue === confirmPinValue;

			if (isEmptyPin) {
				inputValid = false;
			} else if (!isNumericPin) {
				inputValid = false;
				this.handleInputError('input[name="config-pin"]', 602);
			} else if (this.isRepeatingOrSequential(pinValue)) {
				inputValid = false;
				this.handleInputError('input[name="config-pin"]', 600);
			} else {
				this.handleInputError('input[name="config-pin"]', 200);
			}

			if (isEmptyConfirmPin) {
				inputValid = false;
			} else if (!isNumericConfirmPin) {
				inputValid = false;
				this.handleInputError('input[name="confirm-pin"]', 602);
			} else if (!isConfirmed) {
				inputValid = false;
				this.handleInputError('input[name="confirm-pin"]', 601);
			} else {
				this.handleInputError('input[name="confirm-pin"]', 200);
			}

			allChecked = Array.from(checkboxes).every(
				(checkbox) => checkbox.checked
			);

			continueButton.disabled = !(inputValid && allChecked);
			if (inputValid && allChecked) {
				continueButton.classList.add('black-button');
			} else {
				continueButton.classList.remove('black-button');
			}
		};

		inputFields.forEach((input) => {
			input.addEventListener('input', () => {
				input.value = input.value.replace(/[^0-9]/g, '');
				initialCheck = true;
				validateForm();
			});
		});

		checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', () => {
				initialCheck = true;
				validateForm();
			});
		});

		validateForm();
	}

	handleSecurityQuestionsModal() {
		const modal = document.querySelector('.modal-popup.modal-display');
		if (modal) {
			const questionSelectElement = modal.querySelector('select');
			const inputField = modal.querySelector('input');
			const inputName = inputField.name;
			const continueButton = modal.querySelector('.continue');

			continueButton.disabled = true;
			continueButton.classList.remove('black-button');

			const checkAnswer = () => {
				const selectedOption =
					questionSelectElement.options[
						questionSelectElement.selectedIndex
					];
				const questionValue = selectedOption.dataset.question;
				const answerValue = inputField.value.trim();

				const isSelectValid = () =>
					questionSelectElement.value.trim() !== '';

				const isValid =
					isSelectValid() &&
					answerValue !== '' &&
					this.validateSecurityQuestions(questionValue, answerValue);

				if (isValid) {
					this.handleInputError(`input[name="${inputName}"]`, 200);
					continueButton.disabled = false;
					continueButton.classList.add('black-button');
				} else {
					continueButton.disabled = true;
					continueButton.classList.remove('black-button');

					// Xử lý lỗi nếu câu hỏi và câu trả lời trùng nhau
					if (
						!this.validateSecurityQuestions(
							questionValue,
							answerValue
						)
					) {
						this.handleInputError(
							`input[name="${inputName}"]`,
							603
						);
					}
				}
			};

			inputField.addEventListener('input', checkAnswer);
			questionSelectElement.addEventListener('change', checkAnswer);

			checkAnswer();
		}
	}

	validateSecurityQuestions(questionValue, answerValue) {
		if (questionValue && answerValue) {
			// Xóa dấu tiếng việt
			const removeUnicodeCharQues = questionValue
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');
			const removeUnicodeCharAns = answerValue
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');
			// Lowercase
			const lowercaseQuestion = removeUnicodeCharQues.toLowerCase();
			const lowercaseAnswer = removeUnicodeCharAns.toLowerCase();

			// Xóa khoảng trắng đầu và cuối
			const trimmedQuestion = lowercaseQuestion.trim();
			const trimmedAnswer = lowercaseAnswer.trim();

			// Dạng slug
			const slugQuestion = trimmedQuestion.replace(/\s+/g, '-');
			const slugAnswer = trimmedAnswer.replace(/\s+/g, '-');

			return slugQuestion !== slugAnswer;
		}

		return true;
	}

	handleQuestionRecoveryModal() {
		const inputField = document.querySelector(
			'.recovery-question input[name="recovery-answer"]'
		);
		const submitBtn = document.querySelector(
			'.recovery-question .continue'
		);

		const checkInputValidity = () => {
			const isValidInput = inputField.value.trim() !== '';
			if (isValidInput) {
				submitBtn.disabled = false;
				submitBtn.classList.add('black-button');
			} else {
				submitBtn.disabled = true;
				submitBtn.classList.remove('black-button');
			}
		};

		inputField.addEventListener('input', checkInputValidity);

		checkInputValidity();
	}

	handlePinModal() {
		const inputField = document.querySelector(
			'.PIN input[name="login[password]"]'
		);
		const submitBtn = document.querySelector('.PIN .continue');

		if (inputField.value.length !== 6) {
			submitBtn.disabled = true;
			submitBtn.classList.remove('black-button');
		} else {
			submitBtn.disabled = false;
			submitBtn.classList.add('black-button');
		}

		inputField.addEventListener('input', () => {
			inputField.value = inputField.value.replace(/[^0-9]/g, '');

			if (inputField.value.length === 6) {
				submitBtn.disabled = false;
				submitBtn.classList.add('black-button');
			} else {
				submitBtn.disabled = true;
				submitBtn.classList.remove('black-button');
			}
		});
	}

	handleSecurityQuestionModalError() {
		const inputField = document.querySelector(
			'.security-questions input[name="security-answer[1]"]'
		);
		const checkBox = document.querySelector(
			'.security-questions input[name="register[accepts_marketing]"]'
		);
		const submitButton = document.querySelector(
			'.security-questions button[type="submit"]'
		);

		inputField.addEventListener('input', () => {
			const isValidInput = inputField.value.trim() !== '';
			updateSubmitButtonState(isValidInput, checkBox.checked);
		});

		checkBox.addEventListener('change', () => {
			const isValidCheckbox = checkBox.checked;
			updateSubmitButtonState(
				inputField.value.trim() !== '',
				isValidCheckbox
			);
		});

		const updateSubmitButtonState = (isValidInput, isValidCheckbox) => {
			submitButton.disabled = !(isValidInput && isValidCheckbox);

			if (isValidInput && isValidCheckbox) {
				submitButton.classList.add('black-button');
			} else {
				submitButton.classList.remove('black-button');
			}
		};

		// Initial validation (in case elements are pre-filled)
		updateSubmitButtonState(
			inputField.value.trim() !== '',
			checkBox.checked
		);
	}

	handleOtpError(error) {
    if (error?.response?.headers?.ta > 3) {
      this.hideAllOpenModals();
      const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;

      if (error?.response?.data?.error_fields?.[0] === 911) {
        this.handleAuthenticateLimit(
          timeRemaining,
          'loyalty-otp-limit'
        );
      } else if (error?.response?.data?.error_fields?.[0] === 900) {
        this.handleAuthenticateLimit(
          timeRemaining,
          'loyalty-limit-request'
        );
      } else {
        this.handleInputError('input[name="register[phone]"]', error?.response?.data?.error_fields?.[0] || 400);
      }
    }

		if (this.userData.Ta <= 0 || this.userData.Ta > 3) {
			clearInterval(this.countdownInterval);
			this.countdownInterval = null;
		}

		const continueBtn = document.querySelector('.OTP .continue');
		continueBtn.classList.remove('black-button');
		continueBtn.disabled = true;

		let notificationInfoElement = document.querySelector(
			'.modal-display .OTP.notification__info'
		);

		if (notificationInfoElement) {
			notificationInfoElement.innerHTML = `
			<span class="notification__info-otp">
				${this.message.loginOtpModal().desc_with_phone} 
				<span class="user-phone-number">03*****982</span>.
			</span>
			<br>
			<span class="underline-text blue"><b> ${this.message.loginOtpModal().change} </b></span>
		`;
		}

		const changePhone = this.querySelector('.underline-text');
		if (changePhone) {
			changePhone.addEventListener('click', () => {
				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: true,
				});
				const overlay = this.selectors.overlay;
				if (overlay) {
					overlay.dispatchEvent(clickEvent);
				}
			});
		}

		const userPhoneNumberElement =
			document.querySelector('.user-phone-number');
		const maskedPhone =
			this.userData.phoneNumber.slice(0, 2) +
			'*****' +
			this.userData.phoneNumber.slice(7);
		userPhoneNumberElement.textContent = maskedPhone;
		this.selectors.otpContainer.innerHTML = `
			<div class="otp-error">
				<span class="red font-500">
					${this.message.loginOtpModal().not_correct}. ${this.message.loginOtpModal().text}
					${localStorage.getItem('error_attempt') || this.userData.Ta} ${this.message.loginOtpModal().attempt}.
				</span>
			</div>
			<br>
			<div style="margin-top: 12px">
				<span class="no-otp">${this.message.loginOtpModal().no_otp}</span> 
				<span class="new-request underline-text blue">${this.message.loginOtpModal().request}</span>
			</div>
		`;

		const updatedRequestNewOtp = document.querySelector('.new-request');
		let hasClicked = false;

		updatedRequestNewOtp.addEventListener(
			'click',
			() => {
				if (!hasClicked) {
					hasClicked = true;
					this.newOtpRequest();
				}
			},
			{ once: true }
		);

		if (this.userData.Ta <= 0 || this.userData.Ta > 3) {
			const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;
			const endTimeFields = document.querySelectorAll(
				'#loyalty-otp-limit .end-time-group b'
			);

			endTimeFields.forEach((field) => {
				field.textContent = '';
				field.textContent = timeRemaining;
			});

			const userPhoneNumberElement = document.querySelector(
				'#loyalty-otp-limit .user-phone-number'
			);
			userPhoneNumberElement.innerHTML = `${this.userData.phoneNumber}`;

			this.hide('loyalty-otp-modal');
			this.show('loyalty-otp-limit');
		}
	}

	formatDate(isoDateTime) {
		const dateTime = {
			endDate: 'Invalid Date',
			endTime: 'Invalid Time',
		};
		if (!isoDateTime) return dateTime;

		const date = new Date(isoDateTime);

		if (isNaN(date)) {
			return dateTime;
		}

		dateTime.endDate = date.toLocaleDateString('vi-VN');
		dateTime.endTime = date.toLocaleTimeString('vi-VN', {
			hour: '2-digit',
			minute: '2-digit',
		});

		return dateTime;
	}

	getOtpValue() {
		let otp = '';
		let allFilled = true;

		this.selectors.otpInputField.forEach((input) => {
			if (input.value.trim() === '') {
				allFilled = false;
			}
			otp += input.value;
		});

		const submitButton = document.querySelector('.OTP .continue');

		if (otp.length !== this.selectors.otpInputField.length || !allFilled) {
			submitButton.disabled = true;
			submitButton.classList.remove('black-button');
		} else {
			submitButton.classList.add('black-button');
		}

		return otp;
	}

	handleSubmitButton() {
		this.selectors.submitBtn.disabled = true;
		this.selectors.submitBtn.classList.remove('black-button');
	}

	async apiRequest(method, body, params, endpoint) {
		try {
			const headers = {
				'Content-Type': 'application/json',
				'Accept-Language': document.documentElement.lang || 'vi'
			};

      console.log('this.userData?.loginToken', this.userData?.loginToken);
      

			if (this.userData?.customerAccessToken) {
				headers['x-user-token'] = this.userData.customerAccessToken;
			} else if (this.userData?.loginToken) {
				headers['x-user-token'] = this.userData.loginToken;
			}

      console.log('this.provider.hostname + endpoint', this.provider.hostname + endpoint);
      console.log('headers', headers);
      

			const response = await axios({
				method: method,
				url: this.provider.hostname + endpoint,
				headers: headers,
				data: body,
			});
			return response;
		} catch (error) {
			const errorCodes = error?.response?.data?.error_fields || [];
			if (errorCodes.includes(956)) {
				document.dispatchEvent(new CustomEvent('loyalty:session-expired'));
        return;
			}
			throw error;
		}
	}

	isValidPhoneNumber(phone) {
		const isValidFormat = /^0[3-9][0-9]{8}$/.test(phone);

		// Kiểm tra độ dài phải đúng 10 ký tự
		const isCorrectLength = phone.length === 10;

		// Kiểm tra các số không được trùng nhau hoàn toàn (ví dụ: "1111111111" là không hợp lệ)
		const isNotDuplicate = !/^(\d)\1{9}$/.test(phone);

		return isValidFormat && isCorrectLength && isNotDuplicate;
	}

	debounce(func, delay) {
		let timeoutId;
		return (...args) => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	}

	async loginable() {
		const phoneField = this.selectors.phoneField;

		const validatePhone = (phone) => {
			if (phone === '') {
				this.handleInputError('input[name="register[phone]"]', 200);
				this.selectors.submitBtn.disabled = true;
				this.selectors.submitBtn.classList.remove('black-button');
				return false;
			}

			const isValid = this.isValidPhoneNumber(phone);

			if (!isValid) {
				this.handleInputError('input[name="register[phone]"]', 103);
				this.selectors.submitBtn.disabled = true;
				this.selectors.submitBtn.classList.remove('black-button');
			} else {
				this.handleInputError('input[name="register[phone]"]', 200);
				this.selectors.submitBtn.disabled = false;
				this.selectors.submitBtn.classList.add('black-button');
			}

			return isValid;
		};

		phoneField.addEventListener('input', () => {
			phoneField.value = phoneField.value.replace(/[^0-9]/g, '');

			if (phoneField.value.length > 10) {
				phoneField.value = phoneField.value.slice(0, 10);
			}

			validatePhone(phoneField.value);
		});

		const handleSubmit = async (e) => {
			if (e) e.preventDefault();
			const phone = phoneField.value;

			if (!validatePhone(phone)) return;

			this.showLoadingButton(this.selectors.submitBtn);

			const data = JSON.stringify({
				username: phone,
			});

			try {
				const response = await this.apiRequest(
					'POST',
					data,
					{},
					this.apiEndPoint.loginable
				);
        console.log('loginable', response);
        

				if (response.status === 200 && (response?.data?.error_fields?.length === 0 || response?.data?.status === true)) {
					this.handleInputError('input[name="register[phone]"]', 200);
					
					this.userData.acceptable = response?.headers?.acceptable;
					this.userData.phoneNumber = phone;
					this.userData.username = response?.data.username;

					if (response.headers.acceptable === '1') {
            const data = JSON.stringify({
              phone: phone,
              channel: "sms",
            });
            const loginMethodsResponse = await this.apiRequest(
              'POST',
              data,
              {},
              this.apiEndPoint.loginWithOtp
            );
            
            if (loginMethodsResponse.data.status === 200) {
              const newRegisterText = document.querySelector('.new-register-text');
              if (response.data.message !== "1") {
                newRegisterText.style.display = 'none';
              } else {
                newRegisterText.style.display = 'block';
              }
              this.isRegister = false;	
              this.show('loyalty-pin-modal');
            }
					} else if (response.headers.acceptable === '0' || response.headers.acceptable === '2') {
						this.isRegister = (response.headers.acceptable === '0');
						this.show('loyalty-otp-method-modal');
						// this.show('loyalty-expired-session-modal');
					}

					phoneField.value = '';
					validatePhone(phoneField.value);
				} else {
					this.handleInputError('input[name="register[phone]"]', response?.data?.error_fields?.[0]);
				}
			} catch (error) {
				if (
					(error?.response?.data?.error_code === 400 &&
					error?.response?.data?.error_fields?.length === 0)
				) {
					if (error.response.headers.ta.length > 1) {
						alert('Tài khoản của bạn tạm thời bị khoá. Vui lòng thử lại sau');
					} else {
						this.handleGenericError();
					}
				}
        if (error?.response?.data?.error_fields?.[0] === 954) {
          this.hideAllOpenModals();
          this.show('loyalty-temporary-lock-modal');
        } else {
          this.handleInputError(
            'input[name="register[phone]"]',
            error?.response?.data?.error_fields?.[0] || 400
          );
        }
			} finally {
				this.removeLoadingButton(this.selectors.submitBtn);
			}
		};

		this.selectors.submitBtn.addEventListener('click', handleSubmit);
		this.form.addEventListener('submit', handleSubmit);
	}

	closeKeyBoard() {
		document.activeElement.blur();
	}

	showRefCode(refCode) {
		const modal = document.querySelector('.modal-popup.modal-display');
		const refText = modal.querySelector('.otp-ref-code .ref-code');

		if (refText) {
			refText.textContent = '';
			refText.textContent = refCode;
		}
	}

  maskPhone(phone) {
    if (!phone || phone.length < 10) return phone;

    const start = phone.slice(0, 2);
    const end = phone.slice(-3);
    const mask = '*'.repeat(phone.length - 5);

    return start + mask + end;
  }

  maskEmail(email) {
    if (!email || !email.includes('@')) return email;

    const [name, domain] = email.split('@');

    if (name.length <= 4) {
      return name.charAt(0) + '*'.repeat(Math.max(name.length - 1, 0)) + '@' + domain;
    }

    const firstChar = name.charAt(0);
    const lastThree = name.slice(-3);
    const starsCount = name.length - 4;
    const stars = '*'.repeat(starsCount);

    return `${firstChar}${stars}${lastThree}@${domain}`;
  }

	async onSubmit(channel = 'sms') {
		const phone = this.userData.phoneNumber;
		this.userData.channel = channel;
		this.closeKeyBoard();
		const data = JSON.stringify({
			phone: phone,
			channel: channel,
		});

		try {
			if (this.userData.acceptable === '0' || this.userData.acceptable === '2') {
				let response = null;
				if (this.userData.acceptable === '2') {
					response = await this.apiRequest(
						'POST',
						data,
						{},
						this.apiEndPoint.loginWithOtp
					);
				} else if (this.userData.acceptable === '0') {
					response = await this.apiRequest(
						'POST',
						data,
						{},
						this.apiEndPoint.prepareRegister
					);
				}

				if (response?.status !== 200) {
					throw new Error(`API Error: ${response.status}`);
				}

				return { success: true, data: response?.data };
			}
		} catch (error) {
			clearInterval(this.countdownInterval);
			const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;

			if (error?.response.data.error_fields?.[0] === 951) {
        this.hide('loyalty-otp-method-modal');
        const zaloModal = document.getElementById('loyalty-zalo-account-not-existed');
        if (zaloModal) {
          const phoneElement = zaloModal.querySelector('.login-phone');
          if (phoneElement) {
            phoneElement.textContent = this.maskPhone(this.userData.phoneNumber);
          }
        }
        this.show('loyalty-zalo-account-not-existed');
			} else if (
        error?.response.data.error_fields?.[0] === 900 
        || error?.response.data.error_fields?.[0] === 901
      ) {
				this.handleAuthenticateLimit(
					timeRemaining,
					'loyalty-limit-request'
				);
			} else if (error?.response.data.error_fields?.[0] === 911) {
				this.handleAuthenticateLimit(
					timeRemaining,
					'loyalty-otp-limit'
				);
			} else if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			} else {
        this.hide('loyalty-otp-method-modal');
        this.handleInputError('input[name="register[phone]"]', error?.response.data.error_fields?.[0]);
      }

			return { success: false, data: error };
		}
	}

	async newOtpRequest() {
		this.otpSubmitted = false;

		const phone = this.userData.phoneNumber;

		this.selectors.otpInputField.forEach((input) => {
			input.value = '';
		});

		const data = JSON.stringify({
			phone: phone,
			channel: this.userData.channel || 'sms',
		});

		try {
			if (this.userData.acceptable === '0' || this.userData.acceptable === '2') {
				let response = null;
				if (this.userData.acceptable === '2') {
					response = await this.apiRequest(
						'POST',
						data,
						{},
						this.apiEndPoint.loginWithOtp
					);
				} else if (this.userData.acceptable === '0') {
          const requestData = JSON.stringify({
            phone: phone,
            channel: this.userData.channel || 'sms',
            requestAgain: true,
          });
					response = await this.apiRequest(
						'POST',
						requestData,
						{},
						this.apiEndPoint.prepareRegister
					);
				}
				const refCode = response?.data?.ref;
				this.showRefCode(refCode);
				this.countdown();
			}
		} catch (error) {
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields.length === 0
			) {
				this.handleGenericError();
			}

			const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;

			if (error?.response?.data?.error_fields.includes(900)) {
				const endTimeField = document.querySelector(
					'#loyalty-limit-request .end-time-group b'
				);

				endTimeField.textContent = '';
				endTimeField.textContent = timeRemaining;

				const userPhoneNumberElement = document.querySelector(
					'#loyalty-limit-request .user-phone-number'
				);
				userPhoneNumberElement.innerHTML = `${this.userData.phoneNumber}`;
				this.hide('loyalty-otp-modal');
				this.show('loyalty-limit-request');
			} else if (error?.response.data.error_fields?.[0] === 911) {
				this.handleAuthenticateLimit(
					timeRemaining,
					'loyalty-otp-limit'
				);
			} else {
        this.hide('loyalty-otp-method-modal');
        this.handleInputError('input[name="register[phone]"]', error?.response.data.error_fields?.[0]);
      }
		}
	}

	async loginByOTP(username, otp, phone) {
		try {
			const data = JSON.stringify({
				username: phone,
				password: otp,
				txtUsername: username
			});
			
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.login+"?method=otp"
			);


			return response;

		} catch (error) {

			this.removeLoadingButton('.OTP .continue');

			this.userData.Ta = error?.response?.headers?.ta;
			if (this.userData.Ta !== undefined) {
				localStorage.setItem('error_attempt', error?.response?.headers?.ta);
			}
			this.selectors.otpInputField.forEach((input) => {
				input.value = '';
			});

			this.selectors.otpInputField[0].focus();

			this.handleOtpError(error);

			return false;
		}
	}

	async pinModalSubmit(event) {
		event.preventDefault();

		const pinField = document.querySelector(
			'.PIN input[name="login[password]"]'
		);
		pinField.addEventListener('input', () => {
			this.handleInputError('input[name="login[password]"]', 200);
		});

		const formData = new FormData(this.selectors.pinForm);
		const pin = formData.get('login[password]');

		try {
			this.showLoadingButton('.PIN .continue');
			const data = JSON.stringify({
				username: this.userData.phoneNumber,
				password: pin,
			});

			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.login
			);
      

			if (response.status === 200) {
				this.handleInputError(
					'input[name="login[password]"]',
					response.status
				);
			}

			if (response.data.success_fields[0] === 204) {
				await new Promise((resolve) => setTimeout(resolve, 1000));

				this.removeLoadingButton('.PIN .continue');

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: true,
				});
				const overlay = this.selectors.overlay;

				if (overlay) {
					overlay.dispatchEvent(clickEvent);
				}

				this.spinner.show();

				const redirectURL =
					sessionStorage.getItem('redirectURL') || null;

				localStorage.setItem('fromLogin', '1');
				localStorage.setItem('isCheckedRedirect', 'false');

				if (redirectURL !== null) {
					sessionStorage.removeItem('redirectURL');
				}

				let multipassURL = '/account/login/multipass/' + response.data.login_token +
						document.location.search.replace(
							'return_url',
							'return_to'
						);
				
				if (!multipassURL.includes('return_to')) {
					multipassURL += (multipassURL.includes('?') ? '&' : '?') + 'return_to=' + encodeURIComponent(window.theme.routes.accountHome || redirectURL || '/account');
				}

				window.location.href = multipassURL;
			}
		} catch (error) {
			console.error("Error pinModalSubmit: ", error);
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}

			const ta = error?.response?.headers?.ta;
			const remainingAttempts = parseInt(ta);
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;
			let remainingMessage = '';

			if (remainingAttempts < 3) {
				remainingMessage = `. ${this.message.errorMessage().you_have} ${remainingAttempts} ${this.message.errorMessage().attempt_left}.`;
			}
			this.handleInputError(
				'input[name="login[password]"]',
				error?.response?.data?.error_fields?.[0] || 500,
				remainingMessage
			);

			this.removeLoadingButton('.PIN .continue');

      if (error?.response.data.error_fields[0] === 954) {
        this.hideAllOpenModals();
        this.show('loyalty-temporary-lock-modal');
      }

			if (error?.response.data.error_fields[0] === 911) {
				const endTimeField = document.querySelector(
					'#loyalty-limit-pin-submit .end-time-group b'
				);

				if (endTimeField) {
					endTimeField.textContent = '';
					if (!timeRemaining.includes('Invalid')) {
						endTimeField.textContent = timeRemaining;
					}
				}

				const userPhoneNumberElement = document.querySelector(
					'#loyalty-limit-pin-submit .user-phone-number'
				);
				userPhoneNumberElement.innerHTML = `${this.userData.phoneNumber}`;

				this.hideAllOpenModals();
				this.show('loyalty-limit-pin-submit');
			}
		}
	}

  async handleConfirmNewRegister(channel) {
    this.showLoadingButton(this.selectors.confirmNewRegisterBtn);

    const data = JSON.stringify({
      username: this.userData.username,
      channel: channel,
    });

    try {
      const response = await this.apiRequest(
        'POST',
        data,
        {},
        this.apiEndPoint.newAccount
      );

      if (response.status === 200) {
        this.userData.isNewAccountFlow = true;
        this.hideAllOpenModals();
        this.show('loyalty-otp-modal');
        const refCode = response?.data?.data?.otpRefText;
        this.showRefCode(refCode);
        this.countdown();
        this.otpInputFieldChanged();
      }
    } catch (error) {
      console.error('Error handleConfirmNewRegister:', error);
      this.handleOtpError(error);
    } finally {
      this.removeLoadingButton(this.selectors.confirmNewRegisterBtn);
    }
  }

	async otpModalSubmit(otp) {
		const phone = this.userData.phoneNumber;

		const data = JSON.stringify({
			phone: phone,
			oneTimePassword: otp,
		});

		const submitBtn = this.selectors.otpForm.querySelector('.continue');
		try {
      if (this.userData.isNewAccountFlow) {
        this.showLoadingButton(submitBtn);
        const data = JSON.stringify({
          username: this.userData.username,
          otp,
          phoneNumber: this.userData.phoneNumber,
        });
        const response = await this.apiRequest(
          'POST',
          data,
          {},
          this.apiEndPoint.verifyNewAccount
        );
        
        this.removeLoadingButton(submitBtn);

        this.selectors.otpInputField.forEach((input) => {
          input.value = '';
          input.blur();
        });

        if (response.status === 200) {
          this.userData.registerCode = response.data.register_code;
          this.userData.isNewAccountFlow = false;
          try {
            const consentResponse = await this.apiRequest('GET', {}, {}, meowcart.endpoints.portal.getConsents);
            const consents = consentResponse?.data || [];
            const activeConsent = consents.find((c) => c.status === 'Active' || c.status === 'active');
            
            if (activeConsent) {
              this.userData.globalConsent = {
                versionConSent: activeConsent.version,
                linkConsent: activeConsent.url,
                isAcceptConsent: true,
              };
            }
          } catch (error) {
            console.error('Failed to fetch consent in pin config', error);
          }
          this.hideAllOpenModals();
          this.show('loyalty-pin-config');
        }
        return true;
      }

			if (this.userData.acceptable === '0') {
				this.showLoadingButton(submitBtn);
				const response = await this.apiRequest(
					'POST',
					data,
					{},
					this.apiEndPoint.confirmRegister
				);
				this.removeLoadingButton(submitBtn);

				this.selectors.otpInputField.forEach((input) => {
					input.value = '';
					input.blur();
				});

				if (response.status === 200) {
					this.userData.registerCode = response.data.register_code;
          try {
            const consentResponse = await this.apiRequest('GET', {}, {}, meowcart.endpoints.portal.getConsents);
            const consents = consentResponse?.data || [];
            const activeConsent = consents.find((c) => c.status === 'Active' || c.status === 'active');
            
            if (activeConsent) {
              this.userData.globalConsent = {
                versionConSent: activeConsent.version,
                linkConsent: activeConsent.url,
                isAcceptConsent: true,
              };
            }
          } catch (error) {
            console.error('Failed to fetch consent in pin config', error);
          }
					this.hideAllOpenModals();
					this.show('loyalty-pin-config');
				}
			}

			if (this.userData.acceptable === '2') {
				// Bước 1: Gọi login bằng OTP để merge và nhận về token
				this.showLoadingButton(submitBtn);
				const res = await this.loginByOTP(this.userData.username, otp, phone);

				if (!res || res.status !== 200) {
					this.removeLoadingButton(submitBtn);
					return false;
				}

				// Lưu login_token để dùng sau khi tạo PIN + câu hỏi bảo mật xong
				this.userData.loginToken = res.data.login_token;
				this.userData.customerAccessToken = res.data.customer_access_token;
				this.userData.otp = otp;

				// Lấy consent
				try {
					const consentResponse = await this.apiRequest('GET', {}, {}, meowcart.endpoints.portal.getConsents);
					const consents = consentResponse?.data || [];
					const activeConsent = consents.find((c) => c.status === 'Active' || c.status === 'active');
					if (activeConsent) {
						this.userData.globalConsent = {
							versionConSent: activeConsent.version,
							linkConsent: activeConsent.url,
							isAcceptConsent: true,
						};
					}
				} catch (consentError) {
					console.error('Failed to fetch consent in otp flow (acceptable 2)', consentError);
				}

				this.removeLoadingButton(submitBtn);

				this.selectors.otpInputField.forEach((input) => {
					input.value = '';
					input.blur();
				});

				// Bước 2: Hiển thị modal thiết lập PIN
				this.hideAllOpenModals();
				this.show('loyalty-pin-config');
			}

			return true;
		} catch (error) {
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
				return false;
			}

			this.removeLoadingButton(submitBtn);
			this.userData.Ta = error?.response?.headers?.ta;
			if (this.userData.Ta !== undefined) {
				localStorage.setItem('error_attempt', error?.response?.headers?.ta);
			}
			this.selectors.otpInputField.forEach((input) => {
				input.value = '';
			});
			this.selectors.otpInputField[0].focus();

			this.handleOtpError(error);
		}
		return false;
	}

	async pinConfigModalSubmit(event) {
		event.preventDefault();

		const formData = new FormData(this.selectors.configPinForm);
		const pinConfig = formData.get('config-pin');
		const pinConfigConfirm = formData.get('confirm-pin');

		const submitBtn = this.selectors.configPinForm.querySelector('.continue');
		try {
			this.showLoadingButton(submitBtn);
			const response = await this.getSecurityQuestions();
			if (response.success) {
				this.initializeCustomSelects();
			}

			this.userData.PIN = pinConfigConfirm;
			this.hideAllOpenModals();
			this.show('loyalty-get-security-modal');
			new MeowcartCustomSelect().resetCustomSelects();
			this.handleSecurityQuestionsModal();

			// Nếu là luồng acceptable=2 (login bằng OTP, cần tạo PIN lần đầu),
			// rebind submit của securityQuestionForm sang completeRegisterWithPin
			if (this.userData.acceptable === '2') {
				const sqForm = this.selectors.securityQuestionForm;
				sqForm.removeEventListener('submit', this._completeRegisterBound);
				if (!this._completeRegisterWithPinBound) {
					this._completeRegisterWithPinBound = this.completeRegisterWithPin.bind(this);
				}
				sqForm.removeEventListener('submit', this._completeRegisterWithPinBound);
				sqForm.addEventListener('submit', this._completeRegisterWithPinBound);
			}
		} catch (error) {
			console.error('Error fetching security questions:', error);
		} finally {
			this.removeLoadingButton(submitBtn);
		}
	}

	// Luồng acceptable=2: submit câu hỏi bảo mật → gọi createPin API (PATCH) → multipass login → /account
	async completeRegisterWithPin(event) {
		event.preventDefault();

		const formData = new FormData(this.selectors.securityQuestionForm);
		const selectQuestion1 = formData.get('security-question[1]');
		const answer1 = formData.get('security-answer[1]');

		const data = {
			pin: this.userData.PIN,
			sq1: selectQuestion1,
			aq1: answer1,
			versionConSent: this.userData.globalConsent?.versionConSent,
			linkConsent: this.userData.globalConsent?.linkConsent,
			isAcceptConsent: this.userData.globalConsent?.isAcceptConsent,
		};
    console.log('create pin data', data);
    

		const submitBtn = this.selectors.securityQuestionForm.querySelector('.continue');
		try {
			this.showLoadingButton(submitBtn);
			const response = await this.apiRequest(
				'POST',
				JSON.stringify(data),
				{},
				this.apiEndPoint.createPin
			);
      console.log('create pin response', response);
      

			if (response.status === 200) {
				await new Promise((resolve) => setTimeout(resolve, 1000));

				this.removeLoadingButton(submitBtn);

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: true,
				});
				const overlay = this.selectors.overlay;
				if (overlay) {
					overlay.dispatchEvent(clickEvent);
				}

				this.spinner.show();

				const redirectURL = sessionStorage.getItem('redirectURL') || null;

				localStorage.setItem('fromLogin', '1');
				localStorage.setItem('isCheckedRedirect', 'false');

				if (redirectURL !== null) {
					sessionStorage.removeItem('redirectURL');
				}

				let multipassURL = '/account/login/multipass/' + this.userData.loginToken +
						document.location.search.replace('return_url', 'return_to');
				
				if (!multipassURL.includes('return_to')) {
					multipassURL += (multipassURL.includes('?') ? '&' : '?') + 'return_to=' + encodeURIComponent(window.theme.routes.accountHome || redirectURL || '/account');
				}

				window.location.href = multipassURL;
			}
		} catch (error) {
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}
			this.removeLoadingButton(submitBtn);
			this.handleInputError('input[name="security-answer[1]"]');
		}
	}

	async getSecurityQuestions() {
		let attempts = 0;
		const maxAttempts = 3;

		while (attempts < maxAttempts) {
			try {
				const response = await this.apiRequest(
					'POST',
					{},
					{},
					this.apiEndPoint.getSecurityQuestions,
					true
				);

				if (response.status === 200) {
					this.securityQuestions = response.data.questions;

					return { success: true, error: '' };
				}
			} catch (error) {
				this.securityQuestions = {};
				console.error(
					`Attempt ${attempts + 1}: getSecurityQuestions failed`,
					error
				);
				attempts++;
			}
		}

		console.error(
			'getSecurityQuestions: Failed after 3 attempts, reloading page...',
			error
		);
		window.location.reload();
		return { success: false, error: 'Failed after 3 attempts' };
	}

	async completeRegister(event) {
		event.preventDefault();

		const formData = new FormData(this.selectors.securityQuestionForm);
		const selectQuestion1 = formData.get('security-question[1]');
		const answer1 = formData.get('security-answer[1]');

		const data = JSON.stringify({
			username: this.userData.phoneNumber,
			password: this.userData.PIN,
			sq1: selectQuestion1,
			aq1: answer1,
			rc: this.userData.registerCode,
      versionConSent: this.userData.globalConsent?.versionConSent,
      linkConsent: this.userData.globalConsent?.linkConsent,
      isAcceptConsent: this.userData.globalConsent?.isAcceptConsent,
		});

		const submitBtn = this.selectors.securityQuestionForm.querySelector('.continue');
		try {
			this.showLoadingButton(submitBtn);
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.completeRegister
			);
			if (response.status === 200) {
				await new Promise((resolve) => setTimeout(resolve, 1000));

				this.removeLoadingButton(submitBtn);

				const clickEvent = new MouseEvent('click', {
					view: window,
					bubbles: true,
					cancelable: true,
				});
				const overlay = this.selectors.overlay;

				if (overlay) {
					overlay.dispatchEvent(clickEvent);
				}

				this.spinner.show();

				localStorage.setItem('fromLogin', '1');

				let multipassURL = '/account/login/multipass/' + response.data.login_token +
						document.location.search.replace(
							'return_url',
							'return_to'
						);
				
				if (!multipassURL.includes('return_to')) {
					multipassURL += (multipassURL.includes('?') ? '&' : '?') + 'return_to=' + encodeURIComponent((window.theme.routes.accountHome || '/account') + '#tab-account-tab-account-info');
				}

				window.location.href = multipassURL;
			}
		} catch (error) {
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}

			this.removeLoadingButton(submitBtn);
			this.handleInputError('input[name="security-answer[1]"]');
		}
	}

	async emailRecoveryModalSubmit() {
		const data = JSON.stringify({
			username: this.userData.phoneNumber,
		});

		try {
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.pinRecoveryByEmail
			);

			if (response) {
				try {
					const emailResponse = await this.apiRequest(
						'POST',
						JSON.stringify({ phone: this.userData.phoneNumber }),
						{},
						this.apiEndPoint.customerEmail
					);
					if (emailResponse && emailResponse.data && emailResponse.data.email) {
						const email = emailResponse.data.email;
						const maskedEmail = this.maskEmail(email);
						const textElement = document.querySelector('#loyalty-send-success .notification__info-text');
						if (textElement) {
							textElement.innerHTML = `${this.message.emailRecover().desc_success_1} ${maskedEmail} ${this.message.emailRecover().desc_success_2}`;
						}
					}
				} catch (err) {
					console.error('Failed to parse or fetch customer email', err);
				}

				this.hideAllOpenModals();
				this.show('loyalty-send-success');

				return true;
			}
		} catch (error) {
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}

			const ta = error?.response?.headers?.ta;
			const remaining = this.formatDate(Number(ta));
			const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;
      const errorCode = error?.response?.data?.error_fields[0];

      if (errorCode === 936) {
        const errorMessage = this.errorHandling(errorCode);
        this.hideAllOpenModals();
        this.showErrorModal('Lỗi khôi phục Email', errorMessage);
      } else if (errorCode === 907) {
        this.hideAllOpenModals();
        this.show('loyalty-recovery-email');
			} else if (errorCode === 908) {
				this.hideAllOpenModals();
				this.handleAuthenticateLimit(timeRemaining, 'loyalty-limit-email-recover');
			}
			return false;
		}
	}

	async questionRecoveryModalSubmit(event) {
		event.preventDefault();

		const formData = new FormData(this.selectors.questionRecoveryForm);

		const sqRecovery = formData.get('recovery-question');
		const aqRecovery = formData.get('recovery-answer');

		const data = JSON.stringify({
			username: this.userData.phoneNumber,
			q: sqRecovery,
			a: aqRecovery,
		});

		const submitBtn = this.selectors.questionRecoveryForm.querySelector('.continue');
		try {
			this.showLoadingButton(submitBtn);
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.pinRecoveryBySecurityQuestion
			);
			this.userData.recovery_code = response.data.recovery_code;
			if (response.status === 200) {
				this.hideAllOpenModals();
				this.show('loyalty-pin-recovery');
			}
		} catch (error) {
			this.removeLoadingButton(submitBtn);
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}

			const ta = error?.response?.headers?.ta;
			const remainingAttempts = parseInt(ta);
			let remainingMessage = '';
			if (remainingAttempts < 3) {
				remainingMessage = ` ${this.message.errorMessage().you_have} ${remainingAttempts} ${this.message.errorMessage().attempt_left}.`;
			}

			this.handleInputError(
				'input[name="recovery-answer"]',
				error.response.data.error_fields[0],
				remainingMessage
			);

			if (remainingAttempts > 3) {
				const remaining = this.formatDate(Number(ta));
				const timeRemaining = `${remaining.endTime} ${remaining.endDate}`;
				const endTimeField = document.querySelector(
					'#loyalty-limit-recover .end-time-group b'
				);

				endTimeField.textContent = '';
				endTimeField.textContent = timeRemaining;

				const userPhoneNumberElement = document.querySelector(
					'#loyalty-limit-recover .user-phone-number'
				);
				if (userPhoneNumberElement) {
					userPhoneNumberElement.innerHTML = `${this.userData.phoneNumber}`;
				}

				this.hideAllOpenModals();
				this.show('loyalty-limit-recover');
			}
		}
	}

	async recoveryPinModalSubmit(event) {
		event.preventDefault();

		const formData = new FormData(this.selectors.recoverPinForm);
		const pinConfig = formData.get('confirm-recover-pin');

		const data = JSON.stringify({
			username: this.userData.phoneNumber,
			rc: this.userData.recovery_code,
			pin: pinConfig,
		});

		const submitBtn = this.selectors.recoverPinForm.querySelector('.continue');
		try {
			this.showLoadingButton(submitBtn);
			const response = await this.apiRequest(
				'POST',
				data,
				{},
				this.apiEndPoint.resetPinByCode
			);

			if (response) {
				this.hideAllOpenModals();
				this.show('loyalty-recover-success');
			}
		} catch (error) {
			this.removeLoadingButton(submitBtn);
			if (
				error?.response?.data?.error_code === 400 &&
				error?.response?.data?.error_fields?.length === 0
			) {
				this.handleGenericError();
			}

			console.error('recoveryPinModalSubmit', error);
			this.handleInputError(
				'input[name="confirm-recover-pin"]',
				error.response.data.error_fields[0]
			);
		}
	}

	handleAuthenticateLimit(timeRemaining, modalId) {
		const endTimeField = document.querySelector(
			`#${modalId} .end-time-group b`
		);

		if (endTimeField) {
			endTimeField.textContent = '';
			endTimeField.textContent = timeRemaining;
		}

		const userPhoneNumberElement = document.querySelector(
			`#${modalId} .user-phone-number`
		);
		if (userPhoneNumberElement) {
			userPhoneNumberElement.innerHTML = `${this.userData.phoneNumber}`;
		}

		this.hide('loyalty-otp-modal');
		this.show(modalId);
	}

	showErrorModal(title, desc) {
		const modalContainer = document.querySelector(this.selectors.modalContainer);
		const existingModal = modalContainer.querySelector('#loyalty-generic-error-modal');

		if (existingModal) {
			existingModal.remove();
		}

		const modalMarkup = `
            <div class="modal-popup" id="loyalty-generic-error-modal">
                <div class="loyalty-modal">
                    <div class="modal-step active">
                        <header class="modal-header">
                            <p class="notification__important">${title}</p>
                            <button type="button" class="close-modal">
                                <svg
                                    class="close-icon"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15 5L5 15"
                                        stroke="#434343"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M5 5L15 15"
                                        stroke="#434343"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </button>
                        </header>
                        <div class="loyaty-modal-content">
                            <div class="loyalty-message-content">
                                <p>${desc}</p>
                            </div>
                            <div class="button-group">
                                <button class="continue black-button close-error-modal">
                                    ${this.message.continueBtn()}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
		modalContainer.insertAdjacentHTML('beforeend', modalMarkup);

        setTimeout(() => {
		    this.show('loyalty-generic-error-modal');
        }, 10);

		const newModal = document.getElementById('loyalty-generic-error-modal');
		const closeButton = newModal.querySelector('.close-error-modal');
		const closeModalIcon = newModal.querySelector('.close-modal');

		closeButton.addEventListener('click', () => {
			this.hide('loyalty-generic-error-modal');
		});

		closeModalIcon.addEventListener('click', () => {
			this.hide('loyalty-generic-error-modal');
		});
	}

	handleGenericError() {
		const clickEvent = new MouseEvent('click', {
			view: window,
			bubbles: true,
			cancelable: true,
		});
		const overlay = this.selectors.overlay;

		if (overlay) {
			overlay.dispatchEvent(clickEvent);
		}

		alert('Đã xảy ra lỗi không xác định');
	}
}

if (window.location.pathname.includes('/account/login')) {
	customElements.define('crocs-loyalty', CrocsLoyalty);
}
